import { Component } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-field-formula-icon',
  template: `
    <svg
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      [class]="iconClass()"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 4h7a1 1 0 0 1 0.8 1.6L4 14h8"
        stroke="#059669"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M13.5 8.5L16.5 11.5M16.5 8.5L13.5 11.5"
        stroke="#059669"
        stroke-width="1.5"
        stroke-linecap="round" />
    </svg>
  `,
})
export class FieldFormulaIconComponent extends BaseIconComponent {}
